let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2ZapG")).then(() => parcelRequire('6L739'));